var _rect, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMobileIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 318,
    height: 323,
    viewBox: "0 0 318 323",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.239746,
    width: 317.307,
    height: 323,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_301_3",
    transform: "translate(-0.00897021) scale(0.036355 0.0357143)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_301_3",
    width: 28,
    height: 28,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAAABmJLR0QA/wD/AP+gvaeTAAACE0lEQVRIie3WzUsWURTH8c9NUymNCAJLslb+BVFooItw0zaQqI27bCO1KWoVFQS2SWoTLh4poVYtg0wwerGiwrUvkCRlRptMjEfFaTHX1Ap9xsdW9YOBc86cud85c8+5DP+S9qIPeSQFXsPFAPtwHmXFLJJF+XXCajEhrXgCe1ZL3rTMLsPsOoCN6EfA4+gXBMyimxjEWZzGaIyP4kyMD+LGaoskBcKaMSKtpAdtKIn3SnAqxhtjXnOxwE50ST8hS909jUfSPRXvd+F6scAaPEd39Be7eysuoDfGu2NeTbFAOISBaH9DZbSrMBXtgZi3Qutpmhp0YCj6L9Eeoe3RJz0UOmxAhX/aw15ppQ/9hT1c7NIm3PF7l7ZZ6tJhG9ClpPO1OIdvcCnGL0d/Q+fwV53A3Wjfw/HVksMyO0FIcv0VQtkBwj5CtbCwlJOEacFHSfjMwidbPoyFlpbdeIVd0rP0IMYLAia5F0eF5LZ0pgrRtMRbIblv6uut0H4kv9YDK8ciJF0ZYFApaKo7d6zTtu39Sa6/IhuQHRlgPzUyOQ71QnlLVmCRSnaulVG63AmtDcUSX2cCJt0DC9ZRdWhtIBjyruHZWrnLF5+dzn+/mhWWn59TXrqZxLVwMSxkAT6pOnl45v2Xyf2EK3iKmdUenp2f0/GgZ66uunbcWH0u68suHsIF/yZuCmGutKSkz9KB/V9+AGHLqN5jek7DAAAAAElFTkSuQmCC"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileIcon);
export default __webpack_public_path__ + "static/media/Mobile-icon.42ba17ee8e191f64dcc4c71aaec25e8d.svg";
export { ForwardRef as ReactComponent };